module.exports = __webpack_public_path__ + "images/soft-block.8e0220e0ed91350a16db.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/soft-block.svg
// module id = IJV1
// module chunks = 13